export default __webpack_public_path__ + "static/say-as1.1_Tatiana-feb50582fd680e97ad8dbc747c886c4c.wav";